module.exports = __webpack_public_path__ + "img/photo_blue.53760d64.png";